import { IStockTechnicalSummaryData } from "../../interfaces/StockTechnicalSummary.interface";

export type EmaSmaTypes = "EMA" | "SMA";
export const STOCK_TECHNICAL_SUMMARY_TABS: {
  label: string;
  value: keyof IStockTechnicalSummaryData;
}[] = [
  {
    label: "EMA and SMA",
    value: "ema",
  },
  {
    label: "Resistance and support",
    value: "rSupport",
  },
  {
    label: "Delivery and volume",
    value: "dnVol",
  },
  {
    label: "Beta",
    value: "beta",
  },
  {
    label: "Price change analysis",
    value: "pChgAnalysis",
  },
];
export const STOCK_TECHNICAL_SUMMARY_KEYS = {
  ema5Day: "5 Day",
  ema10Day: "10 Day",
  ema12Day: "12 Day",
  ema20Day: "20 Day",
  ema26Day: "26 Day",
  ema50Day: "50 Day",
  ema100Day: "100 Day",
  ema200Day: "200 Day",
  sma5Day: "5 Day",
  sma10Day: "10 Day",
  sma12Day: "12 Day",
  sma20Day: "20 Day",
  sma26Day: "26 Day",
  sma50Day: "50 Day",
  sma100Day: "100 Day",
  sma200Day: "200 Day",
  s1: "First support",
  s2: "Second support",
  s3: "Third support",
  r1: "First resistance",
  r2: "Second resistance",
  r3: "Third resistance",
  macd: "MACD",
  commChannelIndex: "Commodity Channel Index (CCI)",
  williamsR: "Williams % R",
  adx: "ADX",
  rsi: "RSI",
  beta1yr: "1 year",
  beta3yr: "3 years",
  oneMth: "Over 1 month",
  oneYr: "Over 1 year",
  threeMth: "Over 3 months",
  threeYr: "Over 3 years",
  sixMth: "Over 6 months",
  fiveYr: "Over 6 years",
  // sixYr: "Over 6 years",
  date: "Date",
  month: "Month",
  week: "Week",
  sameDay: "Same day",
};
export const STOCK_TECHNICAL_SUMMARY_GRAPH = [
  { "background-color": "#fd7e7f", height: "202px" },
  { "background-color": "#ec858c", height: "186px" },
  { "background-color": "#da8a97", height: "170px" },
  { "background-color": "#cb90a3", height: "154px" },
  { "background-color": "#b999b2", height: "138px" },
  { "background-color": "#ac9fbd", height: "122px" },
  { "background-color": "#97a6cb", height: "106px" },
  { "background-color": "#85acd8", height: "74px" },
  { "background-color": "#7eb1d9", height: "74px" },
  { "background-color": "#80b5cd", height: "106px" },
  { "background-color": "#82b9c0", height: "122px" },
  { "background-color": "#82bbb4", height: "138px" },
  { "background-color": "#84bfa6", height: "154px" },
  { "background-color": "#86c39a", height: "170px" },
  { "background-color": "#88c78f", height: "168px" },
  { "background-color": "#89ca82", height: "202px" },
];
export const STOCK_TECHNICAL_SUMMARY_RESISTANCE_KEYS = [
  "s1",
  "s2",
  "s3",
  "r1",
  "r2",
  "r3",
];

export const STOCK_TECHNICAL_TABS = {
  EMA: "EMA",
  SMA: "SMA",
};

export const STOCK_TECHNICAL_SUMMARY_GRAPH_MOB = [
  { "background-color": "#fd7e7f", height: "102px" },
  { "background-color": "#ec858c", height: "94px" },
  { "background-color": "#da8a97", height: "86px" },
  { "background-color": "#cb90a3", height: "78px" },
  { "background-color": "#b999b2", height: "70px" },
  { "background-color": "#ac9fbd", height: "62px" },
  { "background-color": "#97a6cb", height: "54px" },
  { "background-color": "#85acd8", height: "28px" },
  { "background-color": "#7eb1d9", height: "28px" },
  { "background-color": "#80b5cd", height: "54px" },
  { "background-color": "#82b9c0", height: "62px" },
  { "background-color": "#82bbb4", height: "70px" },
  { "background-color": "#84bfa6", height: "78px" },
  { "background-color": "#86c39a", height: "86px" },
  { "background-color": "#88c78f", height: "94px" },
  { "background-color": "#89ca82", height: "102px" },
];

export const TECHNICAL_ORDER = [
  "rsi",
  "adx",
  "macd",
  "williamsR",
  "commChannelIndex",
];

export const LABEL_WITH_Rs_SYMBOLS = [
  "First support",
  "First resistance",
  "Second support",
  "Second resistance",
  "Third support",
  "Third resistance",
];
